
gsap.registerPlugin(ScrollTrigger)

export const UserFilter = new function() {
    
    this.applyFilter = function(selectedFilter) {
        let itemsToHide = document.querySelectorAll(`.sn-users-list--filtered .sn-user`);
        let itemsToShow = [];
        
        itemsToHide.forEach(item => {
            const filters = item.getAttribute('data-filter').split(' ');
            if (filters.includes(selectedFilter)) {
                itemsToShow.push(item);
            }
        });
        
        itemsToHide.forEach(el => {
            el.classList.add('hide-user');
            el.classList.remove('show-user');
        });
        
        itemsToShow.forEach(el => {
            el.classList.remove('hide-user');
            el.classList.add('show-user'); 
        });
        
        
    };
    
    this.init = function() {
        this.filters = document.querySelectorAll('.sn-user-filter');
        // if(!document.querySelector('.sn-user-filter')) return;

        this.filters.forEach(filter => { 
            filter.addEventListener('click', () => {
                // Remove active class from all filters
                this.filters.forEach(f => f.classList.remove('active'));

                // Add active class to the clicked filter
                filter.classList.add('active');

                // Get the selected filter and apply it
                let selectedFilter = filter.getAttribute('data-filter');
                this.applyFilter(selectedFilter);

                ScrollTrigger.update();
            });
        });
    };
    
};